export class Evento {
    id: number;
    titulo: string;
    descripcion: string;
    categoria:string;
    idCategoria:number;
    fotoUrl:string;
    fecha:Date;
    fechaInciio:Date;
    fechaFin:Date;
    idOrg:string;
    recurrenciaAnual:boolean;
    recurrenciaMensual:boolean;
    recurrenciaSemanal:boolean;
    recurrenciaDiario:boolean;
    mes:number;
    diasemana:number;
    dia:number;
    isAllDay:boolean;
    updateFoto:boolean;
    idEventoPatrocinador:number;
    idIdioma:number;

}

export class EventoTraduccion {
    titulo: string;
    cuerpo: string;
    idIdioma:number;
    nombreIdioma:string;
    idEvento:number;
    filled:boolean;
}
export class Recurrencia {
    id: number;
    nombre: string;
}

export class EventoModel {
    evento: Evento;
    listaTraducciones: EventoTraduccion[];
}
